<template>
  <div class="container-fluid" v-bind:style="backgroundStyle" :class="isMobile() ? 'px-0':''">
    <div class="row no-gutters">
        <RecommendReadThumbnail class="col-4"
                                v-bind:work-item="rankingWorks[0]"
                                v-bind:time-res="timeRes"
                                v-bind:persona-id="personaId"
                                v-bind:restore-token="restoreToken"
                                v-bind:text-style="textStyle"
                                v-bind:button-style="buttonStyle"
                                v-bind:dark-background-style="darkBackgroundStyle"
                                v-bind:read-pages="readPages"
                                v-bind:total-pages="totalPages" />
        <RecommendReadThumbnail class="col-4"
                                v-bind:work-item="rankingWorks[1]"
                                v-bind:time-res="timeRes"
                                v-bind:persona-id="personaId"
                                v-bind:restore-token="restoreToken"
                                v-bind:text-style="textStyle"
                                v-bind:button-style="buttonStyle"
                                v-bind:dark-background-style="darkBackgroundStyle"
                                v-bind:read-pages="readPages"
                                v-bind:total-pages="totalPages" />
        <RecommendReadThumbnail class="col-4"
                                v-bind:work-item="rankingWorks[2]"
                                v-bind:time-res="timeRes"
                                v-bind:persona-id="personaId"
                                v-bind:restore-token="restoreToken"
                                v-bind:text-style="textStyle"
                                v-bind:button-style="buttonStyle"
                                v-bind:dark-background-style="darkBackgroundStyle"
                                v-bind:read-pages="readPages"
                                v-bind:total-pages="totalPages" />
    </div>
    <div class="row no-gutters">
      <RecommendReadThumbnail class="col-4"
                              v-bind:work-item="rankingWorks[3]"
                              v-bind:time-res="timeRes"
                              v-bind:persona-id="personaId"
                              v-bind:restore-token="restoreToken"
                              v-bind:text-style="textStyle"
                              v-bind:button-style="buttonStyle"
                              v-bind:dark-background-style="darkBackgroundStyle"
                              v-bind:read-pages="readPages"
                              v-bind:total-pages="totalPages" />
      <div class="col-4 d-flex align-items-center justify-content-center"
           v-bind:style="buttonStyle">
          <div :style="adWidth()">
              <p class="text-center p-2 recommend-catchphrase" v-bind:style="textStyle">{{ personaText }}</p>
          </div>
          
      </div>
      <RecommendReadThumbnail class="col-4"
                              v-bind:work-item="rankingWorks[4]"
                              v-bind:time-res="timeRes"
                              v-bind:persona-id="personaId"
                              v-bind:restore-token="restoreToken"
                              v-bind:text-style="textStyle"
                              v-bind:button-style="buttonStyle"
                              v-bind:dark-background-style="darkBackgroundStyle"
                              v-bind:read-pages="readPages"
                              v-bind:total-pages="totalPages" />
    </div>
    <div class="row no-gutters">
      <RecommendReadThumbnail class="col-4"
                              v-bind:work-item="rankingWorks[5]"
                              v-bind:time-res="timeRes"
                              v-bind:persona-id="personaId"
                              v-bind:restore-token="restoreToken"
                              v-bind:text-style="textStyle"
                              v-bind:button-style="buttonStyle"
                              v-bind:dark-background-style="darkBackgroundStyle"
                              v-bind:read-pages="readPages"
                              v-bind:total-pages="totalPages" />
      <RecommendReadThumbnail class="col-4"
                              v-bind:work-item="rankingWorks[6]"
                              v-bind:time-res="timeRes"
                              v-bind:persona-id="personaId"
                              v-bind:restore-token="restoreToken"
                              v-bind:text-style="textStyle"
                              v-bind:button-style="buttonStyle"
                              v-bind:dark-background-style="darkBackgroundStyle"
                              v-bind:read-pages="readPages"
                              v-bind:total-pages="totalPages" />
      <RecommendReadThumbnail class="col-4"
                              v-bind:work-item="rankingWorks[7]"
                              v-bind:time-res="timeRes"
                              v-bind:persona-id="personaId"
                              v-bind:restore-token="restoreToken"
                              v-bind:text-style="textStyle"
                              v-bind:button-style="buttonStyle"
                              v-bind:dark-background-style="darkBackgroundStyle"
                              v-bind:read-pages="readPages"
                              v-bind:total-pages="totalPages" />
    </div>
  </div>
</template>

<script>
  import RecommendReadThumbnail from "../components/RecommendReadThumbnail";
  import dynamicStyleMixin from "../components/DynamicStyleMixin";

  export default {
    name: "RecommendPanel",
    components: {RecommendReadThumbnail},
    mixins: [dynamicStyleMixin],
    props: {
      /** @type {Array.<KoreyomoWorkItem>} */
      rankingWorks: {
        type: Array,
        default: () => []
      },

      /** @type {String} */
      personaText: {
        type: String,
        default: () => ""
      },

      /** @type Number} */
      personaId: {
        type: [String, Number],
        default: () => undefined
      },

      /** @type String} */
      timeRes: {
        type: String,
        default: () => null
      },

      /** @type String} */
      restoreToken: {
        type: String,
        default: () => null
      },

      /** @type {KoreyomoWorkInfo|KoreyomoTopWorkItem} */
      workInfo: {
        type: Object,
        default: () => null
      },
      readPages: {
        type: Number,
        default: () => 1
      },
      totalPages: {
        type: Number,
        default: () => 0
      }
    },
    data() {
      return {
        catchPhrase: "",

        /** @type {Array.<KoreyomoWorkItem>} */
        recommendItems: [],
      }
    },
    methods:{
        adWidth:function(){
            if(this.isMobile()){
                return {
                    'line-height' : 'initial',
                    'width' : '50%'
                }
            }else{
                return {
                    'width' : '50%'
                }
            }
        }
    },
    computed: {
      // Override DynamicStyleMixin
      styleObject: function () {
        return this.workInfo
      },
    },
  }
</script>

<style scoped>
  .recommend-catchphrase {
    font-size: 3vmin;
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/components/RecommendPanel.vue